'use strict';

angular.module('far.models.education.discipline', [])
	.service('educationDiscipline', function($log, $http) {
		var list = [],
			firstListQuery = true,
			listQueryProgress = false;

		Object.defineProperty(this, 'list', {
			get: function () {
				if (firstListQuery && !listQueryProgress) {
					listQueryProgress = true;
					$http.get(Routing.generate('api_discipline_get_disciplines'))
						.then(function(response) {
							response.data.forEach(function(item) {
								item.selected = false;
								list.push(item);
							});

							firstListQuery = false;
							listQueryProgress = false;
						})
						.catch(function(response) {
							$log.error(response);
							listQueryProgress = false;
						});
				}

				return list;
			}
		});
	});